import React, { Component } from 'react';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';

export class BookAppointment extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <PageBanner title='Book An Appointment' background='page-banner.jpg' />
        <div className='p-5'>
          <div className='row justify-content-center'>
            <div className='col-md-6'>
              <h3 className='mb-4'>Schedule Your Appointment</h3>
              <p>
                Book a time to speak with one of our printer experts. We offer
                in-store and virtual consultations.
              </p>
              <form>
                <div className='form-group mb-3'>
                  <label htmlFor='name'>Full Name</label>
                  <input
                    type='text'
                    className='form-control'
                    id='name'
                    placeholder='Enter your full name'
                  />
                </div>
                <div className='form-group mb-3'>
                  <label htmlFor='email'>Email Address</label>
                  <input
                    type='email'
                    className='form-control'
                    id='email'
                    placeholder='Enter your email address'
                  />
                </div>
                <div className='form-group mb-3'>
                  <label htmlFor='phone'>Phone Number</label>
                  <input
                    type='tel'
                    className='form-control'
                    id='phone'
                    placeholder='Enter your phone number'
                  />
                </div>
                <div className='form-group mb-3'>
                  <label htmlFor='date'>Preferred Date</label>
                  <input type='date' className='form-control' id='date' />
                </div>
                <div className='form-group mb-3'>
                  <label htmlFor='time'>Preferred Time</label>
                  <input type='time' className='form-control' id='time' />
                </div>
                <div className='form-group mb-3'>
                  <label htmlFor='notes'>Additional Notes</label>
                  <textarea
                    className='form-control'
                    id='notes'
                    rows='3'
                    placeholder='Any specific concerns or questions?'
                  ></textarea>
                </div>
                <button
                  type='submit'
                  className='btn'
                  style={{
                    background: '#2563eb',
                    color: '#fff',
                    fontWeight: 'bold',
                    padding: '10px 30px',
                    borderRadius: '8px',
                  }}
                >
                  Book Appointment
                </button>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default BookAppointment;
